import 'antd/dist/reset.css';
import 'antd-mobile/es/global';
import './global.css';

import { useEffect } from 'react';

import { Outlet } from 'react-router-dom';
import { clientConfig } from 'src/api/axios/config';
import { useGlobal } from 'src/contexts/GlobalContext';
import { useNotifications } from 'src/hooks/useNotifications';
import { queryClient } from 'src/queryClient';

import Layout from '@/components/Layout';

import SidebarDesktop from './components/Sidebar/SidebarDesktop';

const App = () => {
  const { isDesktop } = useGlobal();
  useNotifications();

  useEffect(() => {
    const unsubscribe = clientConfig.subscribe(() => {
      queryClient.invalidateQueries();
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <>
      {isDesktop ? <SidebarDesktop /> : null}
      <Layout>
        <Outlet />
      </Layout>
    </>
  );
};

export default App;
